import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    sweepInfo: {
        id: '_.rbl_dashboard.outstanding.sweep_info',
        defaultMessage:
            ' - repaying monthly with {sweep} of your eligible revenue'
    },
    tooltip: {
        id: '_.rbl_dashboard.outstanding.tooltip',
        defaultMessage:
            'You borrowed {loanAmount} of your approved amount of {maxApprovedAmount} plus the fee of {fees} on {drawDownDate}'
    },
    leftToPayLabel: {
        id: '_.rbl_dashboard.outstanding.leftToPay',
        defaultMessage: 'Left to Pay:'
    },
    estimatedTimeToRepayLabel: {
        id: '_.rbl_dashboard.outstanding.estimatedTimeToRepay',
        defaultMessage: 'Estimated time to repay:'
    },
    lastMonth: {
        id: '_.rbl_dashboard.outstanding.last_month',
        defaultMessage: '1 month'
    },
    months: {
        id: '_.rbl_dashboard.outstanding.months',
        defaultMessage: '{estimatedTimeToRepay} months'
    },
    repaidLabel: {
        id: '_.rbl_dashboard.outstanding.repaid',
        defaultMessage: "You've repaid"
    },
    totalToRepayLabel: {
        id: '_.rbl_dashboard.outstanding.total_to_repay',
        defaultMessage: 'Total taken'
    },
    decideLater: {
        id: '_.rbl_dashboard.outstanding.decide_later',
        defaultMessage: 'I’ll decide later'
    }
});
